import React from 'react';
import '../styles/individualMember.css';
import { LazyLoadImage } from "react-lazy-load-image-component";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook , faInstagram  } from "@fortawesome/free-brands-svg-icons";

function individualMember(props) {
  const {metaData} = props;
  const isGourav = metaData.name === "Gourav Bandyopadhyay";
  
  const displayName = (name) => {
    if (isGourav) {
      const nameParts = name.split(' ');
      return (
        <>
          {nameParts[0]}
          <br />
          {nameParts.slice(1).join(' ')}
        </>
      );
    }
    return name;
  };
  
  return (
    <div className="ind-member-card">
        <div className="member-dp">
            <LazyLoadImage src={metaData.dp} alt={metaData.name} />
        </div>
        <div className="personal-info">{metaData.role}</div>
        <div className="personal-exp">{metaData.exp}</div>
        <span className="name-member">{displayName(metaData.name)}</span>
        {!isGourav && (
          <div className="social">
              <span>
                {metaData.fb ? (
                  <a href={metaData.fb} target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faFacebook} /></a>
                ) : (
                  <span className="icon-disabled"><FontAwesomeIcon icon={faFacebook} /></span>
                )}
              </span>
              <span>
                {metaData.insta ? (
                  <a href={metaData.insta} target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faInstagram} /></a>
                ) : (
                  <span className="icon-disabled"><FontAwesomeIcon icon={faInstagram} /></span>
                )}
              </span>
          </div>
        )}
    </div>
  )
}

export default individualMember;
